import CompetitorTrackingIcon from 'assets/icons/mono/CompetitorTrackingIcon'
import SelfSocialAccountsIcon from 'assets/icons/mono/SelfSocialAccountsIcon'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'reactstrap'
import { toggleLimitExceededModal } from 'slices/ui/reducer'
import { AppDispatch, RootState } from 'store'

const PlanLimitExceededModal: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const membershipData = useSelector((state: RootState) => state.membershipState.membership.data);
    const activePlan = membershipData?.active_plan ?? null;
    const limitExceededModal = useSelector((state: RootState) => state.ui.limitExceededModal)
    const onClose = () => {
        dispatch(toggleLimitExceededModal(null))
    }

    return (
        <Modal className='social-accounts-limit-exceeded-modal position-relative' isOpen={!!limitExceededModal} centered toggle={onClose}>
            <button className="unset-all cursor-all position-absolute" style={{ top: '1rem', right: '1rem' }} onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M29.3307 16.0013C29.3307 23.3651 23.3612 29.3346 15.9974 29.3346C8.6336 29.3346 2.66406 23.3651 2.66406 16.0013C2.66406 8.63751 8.6336 2.66797 15.9974 2.66797C23.3612 2.66797 29.3307 8.63751 29.3307 16.0013ZM11.9569 11.9608C12.3474 11.5703 12.9806 11.5703 13.3711 11.9608L15.9974 14.5871L18.6236 11.9609C19.0141 11.5703 19.6473 11.5703 20.0378 11.9609C20.4283 12.3514 20.4283 12.9846 20.0378 13.3751L17.4116 16.0013L20.0378 18.6275C20.4283 19.018 20.4283 19.6512 20.0378 20.0417C19.6472 20.4322 19.0141 20.4322 18.6235 20.0417L15.9974 17.4155L13.3711 20.0417C12.9806 20.4322 12.3475 20.4322 11.9569 20.0417C11.5664 19.6512 11.5664 19.018 11.9569 18.6275L14.5831 16.0013L11.9569 13.375C11.5664 12.9845 11.5664 12.3514 11.9569 11.9608Z" fill="#9A9A9A" />
                </svg>
            </button>
            <div className="social-accounts-limit-exceeded-body">
                {
                    limitExceededModal === 'max_ig_accounts' &&
                    <>
                        <SelfSocialAccountsIcon size={29} />
                        <h3 className='mt-3 mb-2 social-accounts-limit-exceeded-title'>You can have only {membershipData?.subscription_features?.max_ig_accounts?.applicable_limit ?? 1} social account{(membershipData?.subscription_features?.max_ig_accounts?.applicable_limit ?? 1) > 1 ? 's' : ''} with {activePlan?.plan?.name} plan</h3>
                        <span className='social-accounts-limit-exceeded-description'>Upgrade your plan to create more social accounts</span>
                    </>
                }
                {
                    limitExceededModal === 'max_competitors' &&
                    <>
                        <CompetitorTrackingIcon size={29} />
                        <h3 className='mt-3 mb-2 social-accounts-limit-exceeded-title'>You can have only {membershipData?.subscription_features?.max_competitors?.applicable_limit ?? 1} competitor{(membershipData?.subscription_features?.max_competitors?.applicable_limit ?? 1) > 1 ? 's' : ''} with {activePlan?.plan?.name} plan</h3>
                        <span className='social-accounts-limit-exceeded-description'>Upgrade your plan to add/activate more competitors</span>
                    </>
                }
                <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
                    <button className="btn btn-gradient w-100 d-flex gap-2 align-items-center" onClick={() => navigate('/subscription-plans')}>Explore Plans</button>
                    <button className="btn btn-outline-gradient w-100 d-flex gap-2 align-items-center" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </Modal>
    )
}

export default PlanLimitExceededModal